var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard-root", class: { "dashboard-dark": _vm.isDark } },
    [
      !_vm.fieldsLoading && _vm.editing
        ? _c(
            "div",
            { staticClass: "dash-picker dash-picker--edit" },
            [
              _c(
                "div",
                { staticClass: "dash-seg" },
                _vm._l(_vm.layoutOptions, function (opt) {
                  return _c(
                    "v-btn",
                    {
                      key: opt.value,
                      class: [
                        "dash-tab",
                        { "dash-tab--active": _vm.layout === opt.value },
                      ],
                      attrs: { small: "", depressed: "" },
                      on: {
                        click: function ($event) {
                          return _vm.setLayout(opt.value)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t(opt.label)))]
                  )
                }),
                1
              ),
              _c(
                "v-btn",
                {
                  staticClass: "dash-reset",
                  attrs: { small: "", text: "" },
                  on: {
                    click: function ($event) {
                      _vm.showModulesDialog = true
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { left: "", small: "" } }, [
                    _vm._v("mdi-view-grid-plus-outline"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("message.dashboard.modules")) + " "),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  staticClass: "dash-reset",
                  attrs: { small: "", text: "" },
                  on: { click: _vm.resetLayout },
                },
                [
                  _c("v-icon", { attrs: { left: "", small: "" } }, [
                    _vm._v("mdi-restore"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("message.dashboard.reset")) + " "),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  staticClass: "dash-edit dash-edit--on",
                  attrs: { small: "", depressed: "" },
                  on: { click: _vm.toggleEdit },
                },
                [
                  _c("v-icon", { attrs: { left: "", small: "" } }, [
                    _vm._v("mdi-check"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("message.dashboard.done")) + " "),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.fieldsLoading
        ? _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            _vm._l(12, function (n) {
              return _c(
                "v-col",
                { key: n, attrs: { cols: "4" } },
                [
                  _c(
                    "v-sheet",
                    { staticClass: "mt-2 px-3" },
                    [
                      _c("v-skeleton-loader", {
                        staticClass: "mx-auto",
                        attrs: { type: "image", height: "75" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          )
        : _c(
            "div",
            {
              staticClass: "px-0 mt-2 dashboard-body",
              class: { "is-editing": _vm.editing },
            },
            [
              _vm.editing
                ? _c("p", { staticClass: "dash-tip text-center ma-0 pb-1" }, [
                    _vm._v(
                      _vm._s(
                        _vm.layout === "featured"
                          ? _vm.$t("message.dashboard.editHintFeatured")
                          : _vm.layout === "bento"
                          ? _vm.$t("message.dashboard.editHintBento")
                          : _vm.$t("message.dashboard.editHint")
                      )
                    ),
                  ])
                : _vm._e(),
              _vm.layout === "featured"
                ? _c(
                    "div",
                    { staticClass: "dashboard-body-inner px-2" },
                    [
                      _c("p", { staticClass: "dash-secthead px-1 mb-1" }, [
                        _vm._v(_vm._s(_vm.$t("message.dashboard.featured"))),
                      ]),
                      _c(
                        "draggable",
                        {
                          staticClass: "dash-featured",
                          attrs: {
                            disabled: !_vm.editing,
                            handle: ".dash-cell",
                            group: { name: "feat" },
                            "empty-insert-threshold": 40,
                          },
                          on: { end: _vm.persist },
                          model: {
                            value: _vm.featuredOrder,
                            callback: function ($$v) {
                              _vm.featuredOrder = $$v
                            },
                            expression: "featuredOrder",
                          },
                        },
                        [
                          _vm._l(_vm.featuredTiles, function (navItem) {
                            return _c(
                              "div",
                              {
                                key: "hero_" + _vm.idOf(navItem),
                                staticClass: "dash-feat-card dash-cell",
                              },
                              [
                                _c(
                                  "v-card",
                                  {
                                    staticClass:
                                      "dash-hero d-flex align-center pa-3",
                                    attrs: {
                                      flat: "",
                                      to: _vm.editing ? null : navItem.to,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onTileClick(navItem)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "dash-hero-ic mr-3 d-flex align-center justify-center",
                                      },
                                      [
                                        navItem.icon === "mdi-qrcode-scan"
                                          ? _c(
                                              "svg",
                                              {
                                                staticStyle: {
                                                  width: "26px",
                                                  height: "26px",
                                                },
                                                attrs: {
                                                  viewBox: "0 0 640 512",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    fill: "currentColor",
                                                    d: "M368 64H96c-53 0-96 43-96 96 0 52.4 42.1 94.9 94.3 95.8L6.4 408C-6.9 431 1 460.3 24 473.6l55.4 32c23 13.3 52.3 5.4 65.6-17.6l133.9-232H368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z",
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm.hasSvgIcon(navItem)
                                          ? _c("span", {
                                              staticClass:
                                                "dash-svg-icon d-flex",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  navItem.icon_svg
                                                ),
                                              },
                                            })
                                          : _c(
                                              "v-icon",
                                              { attrs: { dark: "" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    navItem.icon || "mdi-cube"
                                                  )
                                                ),
                                              ]
                                            ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "dash-hero-title flex-grow-1 text-truncate",
                                      },
                                      [_vm._v(_vm._s(_vm.tileLabel(navItem)))]
                                    ),
                                    !_vm.editing
                                      ? _c(
                                          "v-icon",
                                          { staticClass: "dash-hero-arr" },
                                          [_vm._v("mdi-arrow-right")]
                                        )
                                      : _c(
                                          "v-btn",
                                          {
                                            attrs: { icon: "", small: "" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                $event.preventDefault()
                                                return _vm.unpin(navItem)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { small: "" } },
                                              [_vm._v("mdi-close")]
                                            ),
                                          ],
                                          1
                                        ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          _vm.editing && !_vm.featuredTiles.length
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "dash-feat-empty text-center py-4",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("message.dashboard.dragToFeature")
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                      _c("p", { staticClass: "dash-secthead px-1 mb-1 mt-3" }, [
                        _vm._v(_vm._s(_vm.$t("message.dashboard.allModules"))),
                      ]),
                      _c(
                        "draggable",
                        {
                          staticClass: "dash-fgrid",
                          attrs: {
                            disabled: !_vm.editing,
                            handle: ".dash-cell",
                            group: { name: "feat" },
                          },
                          on: { end: _vm.persist },
                          model: {
                            value: _vm.tileOrder,
                            callback: function ($$v) {
                              _vm.tileOrder = $$v
                            },
                            expression: "tileOrder",
                          },
                        },
                        _vm._l(_vm.orderedTiles, function (navItem) {
                          return _c(
                            "div",
                            {
                              key: "fcell_" + _vm.idOf(navItem),
                              staticClass: "dash-fcell dash-cell",
                            },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass:
                                    "dash-fcell-inner d-flex flex-column align-center justify-center pa-2 fill-height",
                                  attrs: {
                                    flat: "",
                                    to: _vm.editing ? null : navItem.to,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onTileClick(navItem)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "dash-fcell-ic d-flex align-center justify-center mb-1",
                                    },
                                    [
                                      navItem.icon === "mdi-qrcode-scan"
                                        ? _c(
                                            "svg",
                                            {
                                              staticStyle: {
                                                width: "24px",
                                                height: "24px",
                                              },
                                              attrs: { viewBox: "0 0 640 512" },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  fill: "currentColor",
                                                  d: "M368 64H96c-53 0-96 43-96 96 0 52.4 42.1 94.9 94.3 95.8L6.4 408C-6.9 431 1 460.3 24 473.6l55.4 32c23 13.3 52.3 5.4 65.6-17.6l133.9-232H368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z",
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm.hasSvgIcon(navItem)
                                        ? _c("span", {
                                            staticClass: "dash-svg-icon d-flex",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                navItem.icon_svg
                                              ),
                                            },
                                          })
                                        : _c("v-icon", [
                                            _vm._v(
                                              _vm._s(navItem.icon || "mdi-cube")
                                            ),
                                          ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "dash-fcell-label text-center",
                                    },
                                    [_vm._v(_vm._s(_vm.tileLabel(navItem)))]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  )
                : _vm.layout === "bento"
                ? _c(
                    "div",
                    { staticClass: "dashboard-body-inner" },
                    [
                      _c(
                        "draggable",
                        {
                          staticClass: "dash-bento px-2",
                          attrs: {
                            disabled: !_vm.editing,
                            handle: ".dash-cell",
                          },
                          on: { end: _vm.persist },
                          model: {
                            value: _vm.tileOrder,
                            callback: function ($$v) {
                              _vm.tileOrder = $$v
                            },
                            expression: "tileOrder",
                          },
                        },
                        _vm._l(_vm.orderedTiles, function (navItem) {
                          return _c(
                            "div",
                            {
                              key: "bento_" + _vm.idOf(navItem),
                              staticClass: "dash-bento-cell dash-cell",
                              class: { "dash-bento-wide": _vm.isWide(navItem) },
                            },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass:
                                    "dash-bento-inner fill-height d-flex align-center justify-center",
                                  attrs: {
                                    tile: "",
                                    flat: "",
                                    to: _vm.editing ? null : navItem.to,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onTileClick(navItem)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-center",
                                      class: _vm.isWide(navItem)
                                        ? "flex-row"
                                        : "flex-column text-center",
                                    },
                                    [
                                      navItem.icon ===
                                        "mdi-newspaper-variant-outline" &&
                                      _vm.unread_count > 0
                                        ? _c(
                                            "v-badge",
                                            {
                                              attrs: {
                                                content: _vm.unread_count,
                                                overlap: "",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "dash-bento-ic d-flex align-center justify-center",
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      _vm._s(
                                                        navItem.icon ||
                                                          "mdi-cube"
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              staticClass:
                                                "dash-bento-ic d-flex align-center justify-center",
                                            },
                                            [
                                              navItem.icon === "mdi-qrcode-scan"
                                                ? _c(
                                                    "svg",
                                                    {
                                                      staticStyle: {
                                                        width: "24px",
                                                        height: "24px",
                                                      },
                                                      attrs: {
                                                        viewBox: "0 0 640 512",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          fill: "currentColor",
                                                          d: "M368 64H96c-53 0-96 43-96 96 0 52.4 42.1 94.9 94.3 95.8L6.4 408C-6.9 431 1 460.3 24 473.6l55.4 32c23 13.3 52.3 5.4 65.6-17.6l133.9-232H368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm.hasSvgIcon(navItem)
                                                ? _c("span", {
                                                    staticClass:
                                                      "dash-svg-icon d-flex",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        navItem.icon_svg
                                                      ),
                                                    },
                                                  })
                                                : _c("v-icon", [
                                                    _vm._v(
                                                      _vm._s(
                                                        navItem.icon ||
                                                          "mdi-cube"
                                                      )
                                                    ),
                                                  ]),
                                            ],
                                            1
                                          ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "font-weight-medium",
                                          class: _vm.isWide(navItem)
                                            ? "ml-3 dash-bento-wide-label"
                                            : "mt-1",
                                        },
                                        [_vm._v(_vm._s(_vm.tileLabel(navItem)))]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm.editing
                                ? _c(
                                    "div",
                                    { staticClass: "dash-bento-exp" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { icon: "", "x-small": "" },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              $event.preventDefault()
                                              return _vm.toggleWide(navItem)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { "x-small": "" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.isWide(navItem)
                                                    ? "mdi-arrow-collapse-horizontal"
                                                    : "mdi-arrow-expand-horizontal"
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "dashboard-body-inner px-2" },
                    [
                      _vm._l(_vm.displayGroups, function (group, gIndex) {
                        return [
                          _vm.layout === "sections"
                            ? _c(
                                "p",
                                {
                                  key: "head_" + gIndex,
                                  staticClass: "dash-secthead px-1 mb-1",
                                  class: { "mt-3": gIndex > 0 },
                                },
                                [_vm._v(_vm._s(_vm.$t(group.label)))]
                              )
                            : _vm._e(),
                          _c(
                            "draggable",
                            {
                              key: "grp_" + gIndex,
                              staticClass: "dash-tgrid",
                              attrs: {
                                value: group.list,
                                disabled: !_vm.editing,
                                handle: ".dash-cell",
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.onGroupReorder(gIndex, $event)
                                },
                                end: _vm.persist,
                              },
                            },
                            _vm._l(group.list, function (navItem) {
                              return _c(
                                "div",
                                {
                                  key: _vm.idOf(navItem) + "_module",
                                  staticClass: "dash-tcell dash-cell",
                                },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass:
                                        "dash-tcell-inner d-flex flex-column align-center justify-center pa-3 fill-height",
                                      attrs: {
                                        flat: "",
                                        to: _vm.editing ? null : navItem.to,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onTileClick(navItem)
                                        },
                                      },
                                    },
                                    [
                                      navItem.icon ===
                                        "mdi-newspaper-variant-outline" &&
                                      _vm.unread_count > 0
                                        ? _c(
                                            "v-badge",
                                            {
                                              attrs: {
                                                content: _vm.unread_count,
                                                overlap: "",
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "dash-tcell-ic d-flex align-center justify-center",
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      _vm._s(
                                                        navItem.icon ||
                                                          "mdi-cube"
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              staticClass:
                                                "dash-tcell-ic d-flex align-center justify-center",
                                            },
                                            [
                                              navItem.icon === "mdi-qrcode-scan"
                                                ? _c(
                                                    "svg",
                                                    {
                                                      staticStyle: {
                                                        width: "24px",
                                                        height: "24px",
                                                      },
                                                      attrs: {
                                                        viewBox: "0 0 640 512",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          fill: "currentColor",
                                                          d: "M368 64H96c-53 0-96 43-96 96 0 52.4 42.1 94.9 94.3 95.8L6.4 408C-6.9 431 1 460.3 24 473.6l55.4 32c23 13.3 52.3 5.4 65.6-17.6l133.9-232H368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm.hasSvgIcon(navItem)
                                                ? _c("span", {
                                                    staticClass:
                                                      "dash-svg-icon d-flex",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        navItem.icon_svg
                                                      ),
                                                    },
                                                  })
                                                : _c("v-icon", [
                                                    _vm._v(
                                                      _vm._s(
                                                        navItem.icon ||
                                                          "mdi-cube"
                                                      )
                                                    ),
                                                  ]),
                                            ],
                                            1
                                          ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "dash-tcell-label text-center mt-2",
                                        },
                                        [_vm._v(_vm._s(_vm.tileLabel(navItem)))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ]
                      }),
                    ],
                    2
                  ),
            ]
          ),
      _c(
        "v-dialog",
        {
          staticClass: "mt-0",
          attrs: { persistent: "", "max-width": "500px" },
          model: {
            value: _vm.scanDialog,
            callback: function ($$v) {
              _vm.scanDialog = $$v
            },
            expression: "scanDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _vm._v(" " + _vm._s(_vm.$t("message.common.scan")) + " "),
              ]),
              _c("v-divider"),
              _c("v-card-text", { staticClass: "pa-1" }, [
                _vm._v(" " + _vm._s(_vm.scanError) + " "),
                _c("div", [
                  _c("video", {
                    ref: "video",
                    staticStyle: {
                      border: "1px solid gray",
                      width: "100%",
                      height: "auto",
                    },
                    attrs: { id: "video" },
                  }),
                ]),
                _vm.videoInputDevices.length > 1
                  ? _c(
                      "div",
                      { attrs: { id: "sourceSelectPanel" } },
                      [
                        _c("v-select", {
                          attrs: {
                            id: "sourceSelect",
                            outlined: "",
                            items: _vm.videoInputDevices,
                            "hide-details": "",
                            "item-text": "label",
                            "item-value": "deviceId",
                            label: _vm.$t("message.common.changeVideoSource"),
                          },
                          model: {
                            value: _vm.selectedDeviceId,
                            callback: function ($$v) {
                              _vm.selectedDeviceId = $$v
                            },
                            expression: "selectedDeviceId",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", id: "scanClose" },
                      on: { click: _vm.stopScanningSession },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.common.close")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          staticClass: "mt-0",
          attrs: { persistent: "", "max-width": "500px" },
          model: {
            value: _vm.showProjectSelectDialog,
            callback: function ($$v) {
              _vm.showProjectSelectDialog = $$v
            },
            expression: "showProjectSelectDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _vm._v(
                  " " + _vm._s(_vm.$t("message.projects.selectProject")) + " "
                ),
              ]),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "pa-1" },
                [
                  _vm.isProjectsByUsedProductLoading
                    ? _c(
                        "v-sheet",
                        { staticClass: "d-flex justify-center pa-5" },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "" },
                          }),
                        ],
                        1
                      )
                    : _c("v-autocomplete", {
                        attrs: {
                          items: _vm.selectableProjectForPickup,
                          "item-text": function (item) {
                            return (
                              (item.po_ranked ? item.po_ranked : "") +
                              " " +
                              (item.project_name
                                ? " - " + item.project_name
                                : "") +
                              " " +
                              (item.ao_ranked ? " - " + item.ao_ranked : "") +
                              " " +
                              (item.work_order_name
                                ? " - " + item.work_order_name
                                : "")
                            )
                          },
                          "item-value": "id",
                          label: _vm.$t("message.projects.selectProject"),
                          "menu-props": "auto, overflowY",
                          outlined: "",
                          dense: "",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.gotoPickup(_vm.seletedProject)
                          },
                        },
                        model: {
                          value: _vm.seletedProject,
                          callback: function ($$v) {
                            _vm.seletedProject = $$v
                          },
                          expression: "seletedProject",
                        },
                      }),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.handleProjectSelection },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.common.close")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "420px", scrollable: "" },
          model: {
            value: _vm.showModulesDialog,
            callback: function ($$v) {
              _vm.showModulesDialog = $$v
            },
            expression: "showModulesDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _vm._v(_vm._s(_vm.$t("message.dashboard.customizeModules"))),
              ]),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "pa-0", staticStyle: { "max-height": "60vh" } },
                [
                  _c(
                    "v-list",
                    { attrs: { dense: "" } },
                    _vm._l(_vm.flatTiles, function (tile) {
                      return _c(
                        "v-list-item",
                        { key: "mod_" + _vm.idOf(tile) },
                        [
                          _c(
                            "v-list-item-icon",
                            { staticClass: "mr-3" },
                            [
                              _vm.hasSvgIcon(tile)
                                ? _c("span", {
                                    staticClass:
                                      "dash-svg-icon dash-svg-icon--list d-flex",
                                    domProps: {
                                      innerHTML: _vm._s(tile.icon_svg),
                                    },
                                  })
                                : _c("v-icon", [
                                    _vm._v(_vm._s(tile.icon || "mdi-cube")),
                                  ]),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v(_vm._s(_vm.tileLabel(tile))),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-action",
                            [
                              _c("v-switch", {
                                attrs: {
                                  "input-value": !_vm.isHidden(tile),
                                  color: "primary",
                                  "hide-details": "",
                                  dense: "",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.toggleModule(tile)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.showModulesDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.common.close")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }